<template>
  <div class="supervisor-intro-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="独立监理" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="image-part">
      <img class="intro-img" src="../../assets/supervisor-intro-one.png">
      <img class="intro-img" src="../../assets/supervisor-intro-two.png">
      <img class="intro-img" src="../../assets/supervisor-intro-three.png">
      <img class="intro-img" src="../../assets/supervisor-intro-four.png">
      <img class="intro-img" src="../../assets/supervisor-intro-five.png">
      <img class="intro-img" src="../../assets/supervisor-intro-six.png">
      <img class="intro-img" src="../../assets/supervisor-intro-seven.png">
    </div>
  </div>
</template>

<script>
  import Header from '../../components/header/Header'
  export default {
    name: 'SupervisorIntro',
    components: {
      'my-header': Header,
    },
    data () {
      return {
          isWechatBrowser:this.$verfyBrowserType()
      }
    },
    created(){

    },
    beforeMount () {
      document.title = this.$route.meta.title;
    },
    methods: {

    }
  }
</script>
<style lang="scss">
  .supervisor-intro-view{
    background: white;
  }
  .intro-img{
    width: 100%;
    display: block;
  }
</style>

